<template>
  <div class="leftCardContainer">
    <div class="rightSideTitleActions">
      <tasks-management-tabs :activeTab="activeTab" :tabs="tabs" @startTabChange="handleTabChange"/>
      <div class="actionsContainer">
        <div class="searchContainer">
          <v-icon> search </v-icon>
          <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
            borderRadius: '0px',
            width: '130px',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: 'none',
          }"
          :inputFieldContainerStyling="{
            padding: '0px 20px',
          }"
          @input="handleSearch($event)" />
        </div>
        <CustomButton
          icon="download "
          :width="'20px'"
          :height="'20px'"
          :iconSize="12"
          :disabled="!selectedObjectUuid"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }"
          @buttonClick="downloadObjects"
        />
        <CustomButton
          icon="print"
          :width="'20px'"
          :height="'20px'"
          :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }"
          :disabled="true"
        />
      </div>
    </div>
    <filter-buttons v-if="!activeTabIsTask" :filters="filters" :activeFilter="activeFilter" @select-filter="handleFilterSelect" />
    <div v-if="activeTab > 1" class="titleContainer">
      <span class="leftTitle">{{ tableTitle  }}</span>
    </div>
    <div class="tableDivContainer" :style="{ 'height': activeTabIsTask ? '90%' : '80%' }">
      <Table :checkbox="false" :loading="loading" :headers="headers" :items="objects" :sortable="true" :scroll-id="mainTableScrollId"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" @onRowClick="updateTaskStepData" :emitRowClickBusEvent="!activeTabIsTask"
      />
    </div>
    <loading-spinner
      :active.sync="loading"
      :is-full-page="false"
      color="#29BDF0"
      style="position: absolute;"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { companyListsMixin } from "@/mixins/management/companyListsMixin";
import { canEditCompanyMixin } from "@/mixins/management/canEditCompanyMixin";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import FilterButtons from "@/newComponents/_Molecules/FilterButtons.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import CustomButton from "@/newComponents/_Atoms/CustomButton.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import LoadingSpinner from "vue-loading-overlay";
import TasksManagementTabs from "@/newComponents/TasksManagement/TasksManagementTabs";

export default {
  name: "TableView",

  mixins: [managementDatatableMixin, companyListsMixin, canEditCompanyMixin, checkPermissionsMixin, activitiesTasksDataMixin],

  components: {
    Table,
    ManagementPage,
    CustomButton,
    InputField,
    LoadingSpinner,
    TasksManagementTabs,
    FilterButtons,
  },

  props: {
    selectedObjectUuid: {
      type: Number,
    },
  },

  data() {
    return {
      loading: false,

      search: null,

      sortOrder: null,

      //pagination
      scrollTop: 0,
      scrollHeight: 0,
      pageNumber: 1,
      lastPage: 2,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      mainTableScrollId: 'main-table-scroll-bar',

      objects: [],

      tabs: [
        {
          label: this.$i18n.tc('Workorder', 2)
        },
        {
          label: this.$i18n.tc('Activity', 2),
        },
      ],
      activeTab: 0,
      activeFilter: null,

      workordersIncludes: "workspace,userCreator",
      activitiesIncludes: "userCreator,fibercloudObject",
      tasksIncludes: "assignedUser",
    };
  },

  mounted() {
    this.getInitialWorkOrders();
    bus.$on("reload-activities", () => this.getInitialActivities())
    bus.$on("reload-workorders", () => this.getInitialWorkOrders())
    bus.$on('on-row-click', data => this.addObjectToTabs(data));
  },

  destroyed() {
    bus.$off("reload-activities");
    bus.$off("reload-workorders");
    bus.$off("on-row-click");
  },

  computed: {
    headers() {
      if (this.activeTab === 0) {
        return [
          { text: this.$i18n.t("State"), varName: "state", function: this.getStateTranslation },
          { text: this.$i18n.tc("Label", 1), varName: "name" },
          { text: this.$i18n.tc("Workspace", 1), varName: "workspace.label", sortVarName: 'workspace' },
          { text: this.$i18n.t("Priority"), varName: "priority.label", sortVarName: 'priority' },
          { text: this.$i18n.t("Creator"), varName: "creator.first_name,creator.last_name", sortVarName: 'creator' },
          { text: this.$i18n.t("StartDate"), varName: "start_date" },
          { text: this.$i18n.t("EndDate"), varName: "end_date" },
        ]
      } else if (this.activeTab === 1 || this.activeTabIsWorkorder) {
        return [
          { text: this.$i18n.t("State"), varName: "state", function: this.getStateTranslation },
          { text: this.$i18n.tc("Label", 1), varName: "title", sortVarName: 'label' },
          { text: this.$i18n.tc("Object", 1), varName: "object.label", sortVarName: 'object' },
          { text: this.$i18n.tc("Layer", 1), varName: "object_type", function: this.getObjectTypeLabel },
          { text: this.$i18n.t("Creator"), varName: "user_creator.first_name,user_creator.last_name", sortVarName: 'creator' },
          { text: this.$i18n.t("DueDate"), varName: "due_date" },
        ]
      } else if (this.activeTabIsActivity) {
        return [
          { text: this.$i18n.t("State"), varName: "state", function: this.getStateTranslation },
          { text: this.$i18n.tc("Label", 1), varName: "title", sortVarName: 'label' },
          { text: this.$i18n.t("Description"), varName: "description" },
          { text: this.$i18n.tc("Assignee", 1), varName: "assignee.first_name,assignee.last_name", sortVarName: 'assignee' },
          { text: this.$i18n.t("ScheduledDate"), varName: "scheduled_date" },
        ]
      } else if (this.activeTabIsTask) {
        return [
          { text: this.$i18n.tc("Label", 1), varName: "label" },
          { text: this.$i18n.tc("Type", 1), varName: "type" },
          { text: this.$i18n.t("Required"), varName: "required", function: this.processBooleanValues },
          { text: this.$i18n.t("Blocked"), varName: "blocked", function: this.processBooleanValues },
        ]
      }
      else return []
    },

    filters() {
      let filters = [
        {
          label: this.$i18n.t('Created'),
          code: "created",
          icon: 'edit',
          color: 'rgba(35, 30, 70, 1)',
        },
        {
          label: this.$i18n.t('InProgress'),
          code: "in_progress",
          icon: 'rotate_right',
          color: 'rgba(248, 141, 43, 1)',
        },
        {
          label: this.$i18n.t('Blocked'),
          code: "blocked",
          icon: 'block',
          color: 'rgba(178, 73, 18, 1)',
        },
        {
          label: this.$i18n.t('Completed'),
          code: "success",
          icon: 'verified',
          color: 'rgba(0, 206, 124, 1)',
        },
      ]

      if (this.activeTab === 0) {
        filters.splice(1, 0, {
          label: this.$i18n.t('ScheduledAdjective'),
          code: "scheduled",
          icon: 'schedule',
          color: 'rgba(41, 189, 240, 1)',
        })
      }

      if (this.activeTabIsActivity) {
        filters.splice(1, 0,
          {
            label: this.$i18n.t('ScheduledAdjective'),
            code: "scheduled",
            icon: 'schedule',
            color: 'rgba(41, 189, 240, 1)',
          },
          {
            label: this.$i18n.t('Reopened'),
            code: "reopened",
            icon: 'verified',
            color: 'rgba(15, 198, 169, 1)',
          },
        )
        filters.splice(5, 0, {
          label: this.$i18n.t('Pending'),
          code: "pending",
          icon: 'verified',
          color: 'rgba(196, 148, 124, 1)',
        })
      }

      return filters;
    },

    activeTabIsWorkorder() {
      return this.tabs[this.activeTab].type === 'workorder';
    },

    activeTabIsActivity() {
      return this.tabs[this.activeTab].type === 'activity';
    },

    activeTabIsTask() {
      return this.tabs[this.activeTab].type === 'task';
    },

    tableTitle() {
      if (this.activeTab === 0) {
        return this.$i18n.tc('Activity', 2);
      }
      if (this.activeTab === 1) {
        return this.$i18n.tc('Task', 2);
      }
      if (this.activeTabIsWorkorder) {
        return this.$i18n.tc('Activity', 2);
      }
      if (this.activeTabIsActivity) {
        return this.$i18n.tc('Task', 2);
      }
      if (this.activeTabIsTask) {
        return this.$i18n.tc('Step', 2);
      }
    },

    queryParams() {
      let queryParams = {
        paginate: this.pagination,
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.activeFilter !== null) {
        queryParams["filter[state]"] = this.filters[this.activeFilter].code;
      }

      return queryParams;
    },
  },

  methods: {
    ...mapActions([
      "fetchAllWorkOrders",
      "fetchAllActivities",
      "fetchWorkOrderActivities",
      "fetchTasksByActivityUuid",
      "fetchStepsByTaskUUID",
      "exportWorkorder",
      "exportActivity",
      "exportTask",
    ]),

    async getInitialActivities() {
      this.pageNumber = 1;
      this.currentPageBot = 1;
      this.currentPageTop = 1;
      this.loading = true;
      try {
        let params = {...this.queryParams, include: this.activitiesIncludes};

        let response = await this.fetchAllActivities({
          params: params,
        });

        this.processData(response);

      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getInitialWorkOrders() {
      this.pageNumber = 1;
      this.currentPageBot = 1;
      this.currentPageTop = 1;
      this.loading = true;
      try {
        let params = {...this.queryParams};
        params["include"] = this.workordersIncludes;
        let response = await this.fetchAllWorkOrders({
          params: params ,
        });

        this.processData(response);

      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getInitialWorkOrderActivities(uuid) {
      this.pageNumber = 1;
      this.currentPageBot = 1;
      this.currentPageTop = 1;
      this.loading = true;
      try {
        let params = {...this.queryParams, include: this.activitiesIncludes};
        let response = await this.fetchWorkOrderActivities({
          uuid: uuid,
          params: params
        });

        this.processData(response);

      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getInitialActivityTasks(uuid) {
      this.pageNumber = 1;
      this.currentPageBot = 1;
      this.currentPageTop = 1;
      this.loading = true;
      try {
        let response = await this.fetchTasksByActivityUuid({
          uuid: uuid,
          params: {...this.queryParams, include: this.tasksIncludes }
        });

        this.processData(response);

      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getInitialTaskSteps(uuid) {
      this.pageNumber = 1;
      this.currentPageBot = 1;
      this.currentPageTop = 1;
      this.loading = true;
      try {
        let response = await this.fetchStepsByTaskUUID({
          uuid: uuid,
          params: this.queryParams,
        });

        this.processData(response);

      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        if (this.objects.length >= (3 * this.pagination)) {
          this.currentPageTop++;
        }
        this.currentPageBot++;
        if (this.activeTab === 0) {
          this.getWorkOrdersBottom();
        } else if (this.activeTab === 1) {
          this.getActivitiesBottom();
        } else if (this.activeTabIsWorkorder) {
          this.getWorkOrderActivitiesBottom(this.tabs[this.activeTab].uuid);
        } else if (this.activeTabIsActivity) {
          this.getActivityTasksBottom(this.tabs[this.activeTab].uuid);
        } else if (this.activeTabIsTask) {
          this.getTaskStepsBottom(this.tabs[this.activeTab].uuid);
        }
      }
    },

    async getActivitiesBottom() {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageBot, include: this.activitiesIncludes };

        let response = await this.fetchAllActivities({
          params: queryParams,
        });

        this.processData(response, 'bottom');

        this.scrollTableBottom();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false
      }
    },

    async getWorkOrdersBottom() {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageBot, include: this.workordersIncludes };

        let response = await this.fetchAllWorkOrders({
          params: queryParams,
        });

        this.processData(response, 'bottom');

        this.scrollTableBottom();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false
      }
    },

    async getWorkOrderActivitiesBottom(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, include: this.activitiesIncludes, page: this.currentPageBot };

        let response = await this.fetchWorkOrderActivities({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'bottom');

        this.scrollTableBottom();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false
      }
    },

    async getActivityTasksBottom(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageBot, include: this.tasksIncludes };

        let response = await this.fetchTasksByActivityUuid({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'bottom');

        this.scrollTableBottom();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false
      }
    },

    async getTaskStepsBottom(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageBot };

        let response = await this.fetchStepsByTaskUUID({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'bottom');

        this.scrollTableBottom();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false
      }
    },

    scrollTableBottom() {
      const currentScroll = document.getElementById(this.mainTableScrollId).scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < this.pagination; i++) {
          const offset = rowHeight * i;
          document.getElementById(this.mainTableScrollId).scrollTo({
            top: currentScroll - offset,
            behavior: "smooth",
          });
        }
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.currentPageTop--;
        if (this.activeTab === 0) {
          this.getWorkOrdersTop();
        } else if (this.activeTab === 1) {
          this.getActivitiesTop();
        } else if (this.activeTabIsWorkorder) {
          this.getWorkOrderActivitiesTop(this.tabs[this.activeTab].uuid);
        } else if (this.activeTabIsActivity) {
          this.getActivityTasksTop(this.tabs[this.activeTab].uuid);
        } else if (this.activeTabIsTask) {
          this.getTaskStepsTop(this.tabs[this.activeTab].uuid);
        }
      }
    },

    async getActivitiesTop() {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageTop, include: this.activitiesIncludes };

        let response = await this.fetchAllActivities({
          params: queryParams,
        });

        this.processData(response, 'top');

        this.scrollTableTop();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getWorkOrdersTop() {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageTop, include: this.workordersIncludes };

        let response = await this.fetchAllWorkOrders({
          params: queryParams,
        });

        this.processData(response, 'top');

        this.scrollTableTop();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getWorkOrderActivitiesTop(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, include: this.activitiesIncludes, page: this.currentPageTop };

        let response = await this.fetchWorkOrderActivities({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'top');

        this.scrollTableTop();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getActivityTasksTop(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageTop, include: this.tasksIncludes };

        let response = await this.fetchTasksByActivityUuid({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'top');

        this.scrollTableTop();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    async getTaskStepsTop(uuid) {
      this.loading = true;

      try {
        let queryParams = { ...this.queryParams, page: this.currentPageTop };

        let response = await this.fetchStepsByTaskUUID({
          uuid: uuid,
          params: queryParams
        });

        this.processData(response, 'top');

        this.scrollTableTop();
      } catch (error) {
        console.error(error);
        this.handleError(error);
        this.objects = [];
      } finally {
        this.loading = false;
      }
    },

    scrollTableTop() {
      const currentScroll = document.getElementById(this.mainTableScrollId).scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < this.pagination; i++) {
          const offset = rowHeight * i;
          document.getElementById(this.mainTableScrollId).scrollTo({
            top: currentScroll + offset,
            behavior: "smooth",
          });
        }
      }
    },

    processData(response, scrollDirection = null) {
      this.lastPage = response.meta.last_page;

      if (scrollDirection) {
        this.objects = scrollDirection === 'bottom'
          ? [...this.objects, ...response.data]
          : [...response.data, ...this.objects];

        if (this.objects.length > 3*this.pagination) {
          this.objects = scrollDirection === 'bottom'
            ? this.objects.slice(this.objects.length - 3*this.pagination)
            : this.objects.splice(-(this.objects.length - 3*this.pagination));
        }
      } else {
        this.objects = response.data;
      }
    },

    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.objects = [];

      this.getInitialObjects();
    }, 1000),

    getInitialObjects() {
      if (this.activeTab === 0) {
        this.getInitialWorkOrders();
      } else if (this.activeTab === 1) {
        this.getInitialActivities();
      } else if (this.activeTabIsWorkorder) {
        this.getInitialWorkOrderActivities(this.tabs[this.activeTab].uuid);
      } else if (this.activeTabIsActivity) {
        this.getInitialActivityTasks(this.tabs[this.activeTab].uuid);
      } else if (this.activeTabIsTask) {
        this.getInitialTaskSteps(this.tabs[this.activeTab].uuid);
      }
    },

    onSortClick(sortOrder, index) {
      let sort = this.headers[index].sortVarName ? this.headers[index].sortVarName : this.headers[index].varName;
      if (sortOrder === "asc") {
        this.sortOrder = sort;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${sort}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialObjects();
    },

    /**
     * Handles errors from the search functions
     * @param {Error} error
     */
    handleError(error) {
      if (error.response) {
        if (error.response.status !== 404) {
          this.$toasted.global.toast_error(error)
        } else if (error.response.status === 404 && error.response.data === "No objects found") {
          this.tasks = [];
        }
      }
    },

    handleTabChange(index) {
      bus.$emit("clear-SelectedItems")
      bus.$emit("clear-selected-row")

      this.activeTab = index;
      this.activeFilter = null;
      this.objects = [];
      this.search = null;
      this.sortOrder = null;
      this.resetPaginationVariables();
      this.getInitialObjects();

      if (index > 1) {
        this.$emit('update-selected-object', { uuid: this.tabs[index].uuid });
        this.$emit('update-selected-object-type', this.tabs[index].type );
      }
    },

    resetPaginationVariables() {
      this.scrollTop = 0;
      this.scrollHeight = 0;
      this.pageNumber = 1;
      this.lastPage = 2;
      this.pagination = 25;
      this.currentPageTop = 1;
      this.currentPageBot = 1;
    },

    handleFilterSelect(index) {
      this.activeFilter = this.activeFilter !== index ? index : null;
      this.getInitialObjects();
    },

    addObjectToTabs(data) {
      let objectType = "";
      // in case the tab selected is the WorkOrders tab or Activities tab
      if (this.activeTab === 0 || this.activeTab === 1) {
        objectType = this.activeTab === 0 ? 'workorder' : 'activity';
        this.tabs = this.tabs.slice(0, 2);
        this.tabs.push({
          uuid: data.uuid,
          label: this.activeTab === 0 ? data.name : data.title,
          type: objectType,
        })

        if (this.activeTab === 0) {
          this.getInitialWorkOrderActivities(data.uuid);
        } else {
          this.getInitialActivityTasks(data.uuid);
        }

        this.activeTab = 2;

      } else if (this.activeTabIsWorkorder) {
        // in case the selected tab is a WorkOrder
        objectType = 'activity';
        this.tabs = this.tabs.slice(0, this.activeTab+1);
        this.tabs.push({
          uuid: data.uuid,
          label: data.title,
          type: objectType,
        })

        this.getInitialActivityTasks(data.uuid);

        this.activeTab = this.activeTab+1;

      } else if (this.activeTabIsActivity) {
        // in case the selected tab is an Activity
        objectType = 'task';
        this.tabs = this.tabs.slice(0, this.activeTab+1);
        this.tabs.push({
          uuid: data.uuid,
          label: data.title,
          type: objectType,
        })

        this.getInitialTaskSteps(data.uuid);

        this.activeTab = this.activeTab+1;
      }

      if (objectType) {
        this.$emit('update-selected-object-type', objectType);
      }
    },

    async downloadObjects() {
      let action;
      if (this.activeTabIsWorkorder) {
        action = 'exportWorkorder'
      } else if (this.activeTabIsActivity) {
        action = 'exportActivity'
      } else if (this.activeTabIsTask) {
        action = 'exportTask'
      }

      try {
        this.loading = true;
        await this.$store.dispatch(action, { uuid: this.selectedObjectUuid});
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    updateTaskStepData(data) {
      if (this.activeTabIsTask) {
        bus.$emit('update-selected-task-step-data', data);
      }
    },

    getStateTranslation(key) {
      return this.$i18n.t(key);
    },

    processBooleanValues(value) {
      return value ? this.$i18n.t('Yes') : this.$i18n.t('No');
    }
  },
}
</script>

<style scoped>
.leftCardContainer {
  text-align: start;
}

.searchContainer {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(118, 118, 118, 0.5);
  margin-right: 8px;
}

.tableDivContainer {
  margin-top: 5px;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.rightSideTitleActions {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid #29bdf0;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px;
  /* 200% */
  text-transform: uppercase;
}

.titleContainer {
  margin-top: 24px;
}

.span-custom {
  display: flex;
  padding: 0px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}

.tableDivContainer >>> .tableContainer .custom-table th {
  padding: 8px 8px 8px 0;
}

.tableDivContainer >>> .tableContainer .custom-table .rowText {
  padding: 8px 8px 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/TasksManagement/TableView.vue